export enum DashboardOption {
  ADD_LABEL = "ADD_LABEL",
  ADVANCED_SHARE = "ADVANCED_SHARE",
  ANNOUNCEMENTS = "ANNOUNCEMENTS",
  ASSET_PANEL = "ASSET_PANEL",
  ASSIGN_PROJECT = "ASSIGN_PROJECT",
  CHANGE_MASTER = "CHANGE_MASTER",
  CONFIRM_ACCOUNT_DELETE = "CONFIRM_ACCOUNT_DELETE",
  CREATE = "CREATE",
  CREATE_FROM_TEMPLATE = "CREATE_FROM_TEMPLATE",
  DELETE = "DELETE",
  DELETE_TEMPLATE = "DELETE_TEMPLATE",
  DOWNLOAD = "DOWNLOAD",
  DROP_SCOPE = "DROP_SCOPE",
  DUPLICATE = "DUPLICATE",
  EXPANDED_SHARE = "EXPANDED_SHARE",
  FILTER = "FILTER",
  HIDE = "HIDE",
  INFO = "INFO",
  INVITE = "INVITE",
  LEAVE = "LEAVE",
  LINKED_MASTER = "LINKED_MASTER",
  MANAGE_ACCOUNT = "MANAGE_ACCOUNT",
  NEXUS_INSIGHTS_PANEL = "NEXUS_INSIGHTS_PANEL",
  NOTIFICATION_CENTER = "NOTIFICATION_CENTER",
  OPEN = "OPEN",
  OPTIONS = "OPTIONS",
  OPTIONS_FAVORITE = "OPTIONS_FAVORITE",
  PERMISSIONS = "PERMISSIONS",
  REMOVE = "REMOVE",
  REMOVE_FROM_PROJECT = "REMOVE_FROM_PROJECT",
  REQUESTING_SNAPSHOT = "REQUESTING_SNAPSHOT",
  SEARCH_WORKSPACE = "SEARCH_WORKSPACE",
  SHARE = "SHARE",
  SHOW_TASK_LOCATIONS = "SHOW_TASK_LOCATIONS",
  UPLOAD = "UPLOAD",
  UPSELL = "UPSELL",
}
